// extracted by mini-css-extract-plugin
module.exports = {"cropImage":"crop-image-module--cropImage--3vvgJ"};